import $ from 'jquery';
import * as bootstrap from 'bootstrap';

window.jQuery = window.$ = $;
window.bootstrap = bootstrap;

$.fn.extend({
    isArray: function() {
        return Array.isArray(this);
    },
});

import jBob from 'jbob';
var j = new jBob();
window.j = j;
